import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';
import { HelpType } from '../../components/common/help/help.service';
import { ExecutionDivisionDTO, getSimpleIdentifierFromString, getParentIdentifierFromString } from '../../api/plyca-dtos';
import { ContractDTO } from '../../api/plyca-dtos-v2';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';

// templateUrl: 'customField.edition.template.html'
@Component({
  selector: 'executionDivision-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class ExecutionDivisionEditionComponent
  extends BaseFormComponent<ExecutionDivisionDTO, ExecutionDivisionDTO>
  implements OnInit, OnDestroy {
  private identifier: string;
  private contract: ContractDTO;
  private creating = false;

  constructor(
    elem: ElementRef,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.contract = dialogConfig['contract'];
    this.windowHash = generateRandomIdentifier();
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'contracts/executionDivisionISettings.json';
  }

  getServiceURL(): string {
    //TODO: Hay que unificar las URLs de los servicios de executionDivisions
    let url = this.configuration.EXECUTION_PHASE_DOSSIER_SERVICE_URL.replace(
      '{dossierId}',
      getParentIdentifierFromString(this.contract.division.identifier)
    );
    if (!this.identifier && !this.creating)
      url = this.configuration.EXECUTION_PHASE_CONTRACT_SERVICE_URL.replace(
        '{contractId}',
        getParentIdentifierFromString(this.contract.identifier)
      );
    this.creating = false;
    return url;
  }

  getObjectIdentifier(): string {
    if (this.identifier)
      return getSimpleIdentifierFromString(this.identifier);
    else {
      this.creating = true;
      return 'new';
    }
  }
  getObjectParams(): { [param: string]: string | string[] } {
    if (!this.identifier) {
      return {
        'parentDivisionId': getSimpleIdentifierFromString(this.contract.division.identifier)
      };
    } else
      return undefined;
  }


  dtoToModel(dto: ExecutionDivisionDTO): Observable<ExecutionDivisionDTO> {
    return of(dto);
  }

  modelToDTO(model: ExecutionDivisionDTO): ExecutionDivisionDTO {
    if (model.certificationName != null) {
      model.name = 'Certificación ' + model.certificationName;
    }
    // Al ser un subordianteid si tiene solo la propuesta tenemos que eliminarlo entero
    // para que se invoque al insert y no al update
    if (model.identifier) {
      let id = getSimpleIdentifierFromString(model.identifier);
      if (id == 'nulo')
        model.identifier = null;
    }

    return model;
  }

  getTitle(model: ExecutionDivisionDTO): string {
    if (model) {
      return model.identifier;
    } else {
      return 'Nuevo grupo';
    }
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Communications.detail.form.title';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    return headerInfo;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.searchTags = [HelpType.EXECUTION_DIVISION];
    // formConfig.readonly = this.readonly;
    return of(formConfig);
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash),
      () => {
        this.subscribe(this.save(), () => this.close());
      });
    // this.headerActionsService.addWindowDivider(this.windowHash);
    // this.addBackAction();
  }

  close() {
    this.ref.close();
    this.waitService.cancelWaiting();
  }
}
